import React, { useState, useEffect } from "react";
import localforage from "localforage";
import Accordian from "../../components/Accordian/Accordian";
import Loader from "examples/Loader";
import { useAgencyInfo } from "context/agency";
import ModelPromptView from "./ModelPrompts/View";
import ModelPromptEdit from "./ModelPrompts/Edit";
import { Card, Grid, Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Swal from "sweetalert2";
import CreateTemplate from "layouts/super-admin/Assistants/Components/CreateTemplate";
import env from "config/env";
import AddCategoryPrompt from "layouts/super-admin/Assistants/Components/Category/AddCategoryPrompt";
import AddSubCategoryPrompt from "layouts/super-admin/Assistants/Components/SubCategory/AddSubCategoryPrompt";
import PushPinIcon from "@mui/icons-material/PushPin";
import { useSuperAdminSettings } from "queries/prompts";
import { useManagePromptDetails } from "queries/promptCategories";
import { useUpdatePromptLabel, useDeletePromptLabelWithToaster, useAddFavouritePromptLabel } from "queries/promptLabels";

function CustomPrompt({
  handleRefresh,
  loadcategory,
  data,
  fromAdmin = false,
  setSearchQuery,
  searchQuery,
}) {
  const [loader, setLoader] = useState(true);
  const [isModalOpenView, setIsModalOpenView] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [category, setcategory] = useState(data);
  const [modalData, setModalData] = useState({});
  const [modalDataEdit, setModalDataEdit] = useState({});
  const [agency] = useAgencyInfo();
  const [Accordians, setAccordians] = useState([]);

  useEffect(() => {
    setLoader(false);
    loadcategory();
  }, []);

  const { data: supperAdminData } = useSuperAdminSettings();

  const { mutateAsync: deletePromptLabel } = useDeletePromptLabelWithToaster();

  const handleDelete_sub_Category_prompt = (item, idx) => {
    Swal.fire({
      title: "Warning",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
    }).then(async (res) => {
      if (!res.isConfirmed) return;
      const { response } = await deletePromptLabel(item._id);
      if (response) {
        loadcategory();
      }
    });
  };

  const { mutateAsync: getManagePromptDetails } = useManagePromptDetails();

  const openModelView = async (data) => {
    const { response } = await getManagePromptDetails({ agencyId: agency._id, promptId: data._id });
    if (response) {
      setModalData(response.data);
      setIsModalOpenView(true);
    }
  };
  const openModelEdit = async (data) => {
    setModalDataEdit(data);
    setIsModalOpenEdit(true);
  };

  const { mutateAsync: updatePromptLabel } = useUpdatePromptLabel();

  const Editdata = async (formData) => {
    setLoader(true);
    const updatedFormData = { ...formData, agency_id: agency._id };

    const { response } = await updatePromptLabel(updatedFormData);
    if (response) {
      handleclose();
      loadcategory();
      setLoader(false);
    }
  };
  const handleclose = () => {
    setIsModalOpenView(false);
    setIsModalOpenEdit(false);
    loadcategory();
  };

  const filteredData = Array.isArray(data)
    ? data.filter(
      (item) => item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) // Case-insensitive search
    )
    : [];

  const { mutateAsync: addFavouritePromptLabel } = useAddFavouritePromptLabel();

  const handlePinClick = async (promptslabel_id) => {
    const { response } = await addFavouritePromptLabel({ template_id: promptslabel_id, agency_id: agency._id });
    if (response?.success)
      window.alert('Tempalate updated')
    loadcategory()
  }

  return (
    <div>
      {loader === false ? (
        <>
          <Grid2 container spacing={2}>
            <Grid2 item xs={12} style={{ position: "relative" }}>
              <SoftBox pt={3}>
                <div
                  style={{
                    position: "relative",
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div style={{ position: "absolute", left: "10px", top: "20px" }}>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_282_92)">
                          <path
                            d="M15 13.2955L12.3767 10.7727C13.1166 9.68182 13.5202 8.31818 13.5202 6.88636C13.5202 3.06818 10.4933 0 6.79372 0C3.09417 0 0 3.06818 0 6.88636C0 10.7045 3.02691 13.7727 6.79372 13.7727C8.27354 13.7727 9.61883 13.2955 10.6951 12.4773L13.3184 15.0682L15 13.2955ZM2.35426 6.88636C2.35426 4.43182 4.30493 2.45455 6.72646 2.45455C9.14798 2.45455 11.0987 4.43182 11.0987 6.88636C11.0987 9.34091 9.14798 11.3182 6.72646 11.3182C4.3722 11.3182 2.35426 9.34091 2.35426 6.88636Z"
                            fill="#E5E5E5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_282_92">
                            <rect width="15" height="15" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <input
                      type="text"
                      placeholder="Search by name..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{
                        padding: "30px 45px",
                        width: "100%",
                        fontSize: "18px",
                        boxSizing: "border-box",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {/* <CreateTemplate handleRefresh={loadcategory} supperAdminData={supperAdminData} /> */}
                    {/* <button
                    className="btn-new-design-black"
                    onClick={opemmodel}
                    >
                    Add Tag
                  </button> */}
                  </div>
                </div>

                <div style={{ marginTop: "70px" }}>
                  {filteredData.length > 0 &&
                    filteredData.map((item, index) => (
                      <div
                        key={index}
                        className="w-100 tablebody-row"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Tooltip title={item?.template?.templatename ? item?.template?.templatename : item?.name} placement="top">
                          <div
                            className="p-20-px text-black text-bold text-left"
                            style={{ width: "150px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                          >
                            {item?.template?.templatename ? item?.template?.templatename : item?.name}
                          </div>
                        </Tooltip>

                        <div className="text-black text-bold" style={{ width: "150px" }}>
                          {item?.api_type === "team" ? "Account" : "User"}
                        </div>

                        <div
                          className="p-20-px text-black text-left "
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {fromAdmin ? (() => {
                            const catRecord = item?.superadmin_template_cats?.find(c => c.type === 'category');
                            const catToDisplay = catRecord
                              ? agency?.Categories?.find(c => c._id?.toString() === catRecord.item_id || c.id === catRecord.item_id)
                              : null;
                            return catToDisplay ? (
                              <span style={{ background: catToDisplay.color, padding: "5px 15px", borderRadius: "20px", marginRight: "10px" }}>
                                {catToDisplay.name}
                              </span>
                            ) : null;
                          })() : (() => {
                            let categoryToDisplay = null;
                            if (Array.isArray(item?.category)) {
                              categoryToDisplay = item.category.find(cat => cat.agency_id === agency._id);
                            } else if (item?.category && item?.category.agency_id === agency._id) {
                              categoryToDisplay = item.category;
                            }
                            return categoryToDisplay ? (
                              <span style={{ background: categoryToDisplay?.color, padding: "5px 15px", borderRadius: "20px", marginRight: "10px" }}>
                                {categoryToDisplay?.name}
                              </span>
                            ) : null;
                          })()}
                          <AddCategoryPrompt item={item} handleRefresh={handleRefresh} fromAdmin={fromAdmin} />
                        </div>

                        <div
                          className="p-20-px text-black text-left "
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span style={{ display: "flex" }}>
                            {fromAdmin ? (() => {
                              const tagRecords = item?.superadmin_template_cats?.filter(c => c.type === 'tag') || [];
                              const tagsToDisplay = tagRecords
                                .map(r => agency?.SubCategories?.find(s => s._id?.toString() === r.item_id || s.id === r.item_id))
                                .filter(Boolean);
                              return (
                                <>
                                  {tagsToDisplay.slice(0, 1).map((tag, index) => (
                                    <span key={index} style={{ background: "#F3F4F6", padding: "5px 15px", borderRadius: "20px", marginRight: "10px", marginBottom: "5px", display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                      {tag.name}
                                    </span>
                                  ))}
                                  {tagsToDisplay.length > 1 && (
                                    <span style={{ background: "#E7ECF3", padding: "5px 15px", borderRadius: "20px", marginRight: "10px", marginBottom: "5px", cursor: "default" }}>
                                      {tagsToDisplay.length - 1} more
                                    </span>
                                  )}
                                </>
                              );
                            })() : (() => {
                              const agencySubs = item?.subCategory?.filter(
                                sub => sub.agency_id === agency._id && agency.SubCategories?.some(cat => cat.id === sub.id)
                              ) || [];
                              return (
                                <>
                                  {agencySubs.slice(0, 1).map((data, index) => (
                                    <span key={index} style={{ background: "#F3F4F6", padding: "5px 15px", borderRadius: "20px", marginRight: "10px", marginBottom: "5px", display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                      {data?.name}
                                    </span>
                                  ))}
                                  {agencySubs.length > 1 && (
                                    <span style={{ background: "#E7ECF3", padding: "5px 15px", borderRadius: "20px", marginRight: "10px", marginBottom: "5px", cursor: "default" }}>
                                      {agencySubs.length - 1} more
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </span>
                          <AddSubCategoryPrompt item={item} handleRefresh={handleRefresh} fromAdmin={fromAdmin} />
                        </div>
                        <div className="p-20-px text-black text-bold text-left w-32-per">
                          {item.createdAt &&
                            new Date(item.createdAt).toLocaleString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                        </div>
                        <div className="text-right" style={{ paddingRight: "30px" }}>
                          <div style={{ display: "flex", justifyContent: "end" }}>
                            {item?.agency_id === agency?._id && <Tooltip title="Pin" arrow>
                              <div style={{ marginInline: '22px', cursor: "pointer" }} onClick={() => handlePinClick(item?.template?.id)}>
                                <PushPinIcon sx={{ color: item?.pin ? "#000" : "#c9c9c9", fontSize: "26px" }} />
                              </div>
                            </Tooltip>}
                            {!fromAdmin && (
                              <>
                                <div
                                  className="cursor-pointer"
                                  onClick={async () => {
                                    if (item?.template?.thread_id) {
                                      // agent-builder has no login/token of
                                      // its own - it's an Agency-session
                                      // tool, so it borrows this session's.
                                      const token = await localforage.getItem("token");
                                      window.open(
                                        `${env.AGENT_BUILDER_URL}agency_id=${agency._id}&thread_id=${item.template.thread_id}&token=${token}`,
                                        "agentBuilder",
                                        "width=1000,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=no"
                                      );
                                    } else {
                                      openModelEdit(item);
                                    }
                                  }}
                                  style={{ marginRight: "20px" }}
                                >
                                  <Icon>edit</Icon>
                                </div>
                                <div
                                  className="cursor-pointer"
                                  onClick={() => handleDelete_sub_Category_prompt(item, index)}
                                >
                                  <Icon>delete</Icon>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </SoftBox>
            </Grid2>
          </Grid2>
          {isModalOpenView && (
            <ModelPromptView
              handleRefresh={handleRefresh}
              data={modalData}
              modelfunctionality={handleclose}
              openModel={isModalOpenView}
              onclosemodel={handleclose}
            />
          )}
          {isModalOpenEdit && (
            <ModelPromptEdit
              handleRefresh={handleRefresh}
              data={modalDataEdit}
              loadcategory={loadcategory}
              openModel={isModalOpenEdit}
              onclosemodel={handleclose}
            />
          )}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default CustomPrompt;
const Categories = ({ data }) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((item, index) => (
          <>
            <div className="d-flex w-100 tablebody-row" style={{ alignItems: "center" }}>
              <div className="p-20-px text-black text-bold text-left w-50"> {item.name} </div>
            </div>
          </>
        ))}
    </>
  );
};
